import React, { useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import { useGetEventAssetsSolutionsQuery } from "../store/slices/settingsSlice";
import Assets from "../Assets/Assets";
import AssetList from "../Assets/AssetList";
import MyPagination from "../Common/MyPagination";

export default function EventsAssetsSlider({ item }) {
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 12,
    search: "",
    kind: "",
  });
  const { data: assetsData = { assets: [], total: 0 } } =
    useGetEventAssetsSolutionsQuery(
      {
        uuid: item.Uuid,
        ...filters,
      },
      { skip: !show }
    );

  return (
    <div>
      <Button
        variant=""
        onClick={handleShow}
        className="fw-bold text-white badge bg-secondary"
      >
        List
      </Button>
      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{ width: "800px" }}
        size="xl"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Assets Related to Event</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {assetsData && assetsData.assets?.length > 0 ? (
            <AssetList assets={assetsData.assets} showTable />
          ) : (
            // <ul>
            //   {assetsData.assets?.map((asset) => (
            //     <li key={asset.Uuid}>
            //       {asset.Label} ({asset.Uuid})
            //     </li>
            //   ))}
            // </ul>
            <p>No assets related to this event.</p>
          )}
          <MyPagination
            total={assetsData.total}
            onPaginate={(page, perPage) => {
              setFilters({ ...filters, page, perPage });
            }}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}
